<template>
	<widget-card
		colClasses="xs12"
		:heading="widget.caption[$i18n.locale]">
		<gradient-line-chart></gradient-line-chart>

	</widget-card>
</template>

<script>
	import GradientLineChart from './GradientLineChart.js'

	export default {
		props: {
			widget: {
				type: Object,
				required: true
			}
		},
		components: {
			GradientLineChart
		},
		data() {
			return {

			}
		},
		methods: {
			
		}
	};
</script>

